'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppWarning = function AppWarning(props) {
    return _react2.default.createElement(
        'div',
        { className: 'mx_AppPermissionWarning' },
        _react2.default.createElement(
            'div',
            { className: 'mx_AppPermissionWarningImage' },
            _react2.default.createElement('img', { src: require("../../../../res/img/warning.svg"), alt: '' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'mx_AppPermissionWarningText' },
            _react2.default.createElement(
                'span',
                { className: 'mx_AppPermissionWarningTextLabel' },
                props.errorMsg
            )
        )
    );
}; // eslint-disable-line no-unused-vars


AppWarning.propTypes = {
    errorMsg: _propTypes2.default.string
};
AppWarning.defaultProps = {
    errorMsg: 'Error'
};

exports.default = AppWarning;
module.exports = exports['default'];
//# sourceMappingURL=AppWarning.js.map